import * as Raven from 'raven-js';
import { ErrorHandler } from '@angular/core';
import { environment } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
Raven.config(environment.sentryUrl).install();
var RavenErrorHandler = /** @class */ (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        // Throw error if in dev mode. Otherwise there would be no error shown in browser console
        // If not in dev mode, capture error to sentry.
        if (!environment.production) {
            console.error(err);
        }
        else {
            Raven.captureException(err);
        }
    };
    return RavenErrorHandler;
}());
export { RavenErrorHandler };
// the second parameter 'de' is optional
registerLocaleData(localeDe, 'de');
var ɵ0 = environment.apiUrl;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
